export { default } from "./tabs-provider";
